import React from "react";
import { X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "@/components/ui/dialog";

export const VideoTutorialModal = ({ open, onOpenChange, title, src, testId = "video-modal" }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={testId}
        className="max-w-5xl p-0 gap-0 bg-white border-0 rounded-3xl shadow-2xl overflow-hidden [&>button]:hidden"
      >
        <div className="kw-red-bar h-1 w-full" />

        <DialogHeader className="px-6 md:px-8 py-4 border-b border-[color:var(--kw-border)] flex-row items-center justify-between space-y-0">
          <div className="min-w-0">
            <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-[color:var(--kw-red)] mb-0.5">
              Tutorial
            </div>
            <DialogTitle className="font-display text-xl md:text-2xl font-black tracking-tight text-[color:var(--kw-charcoal)] uppercase truncate">
              {title}
            </DialogTitle>
          </div>
          <DialogClose
            data-testid={`${testId}-close`}
            className="text-[color:var(--muted-foreground)] hover:text-[color:var(--kw-charcoal)] transition-colors"
          >
            <X size={22} strokeWidth={2.5} />
          </DialogClose>
        </DialogHeader>

        <div className="bg-black">
          {open && src ? (
            <iframe
              key={src}
              src={src}
              title={title}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              className="block w-full border-0"
              style={{ aspectRatio: "1920 / 1080" }}
            />
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoTutorialModal;
